import {
  BIconPeople,
  BIconPerson,
  BIconLock,
  BIconLink,
} from 'bootstrap-vue'

export default {

  data() {
    return {
      tabNumber: 0,
      isHidden: false,
      finalTabItems: [],
    }
  },
  computed: {
    route() {
      return this.$route.path
    },
    filtredtabsItem() {
      return [
        {
          title: 'general',
          link: { name: 'profile-general', params: {} },
          number: 0,
          icon: BIconPerson,
        },
        {
          title: 'security',
          link: { name: 'profile-security', params: {} },
          number: 1,
          icon: BIconLock,
        },

        {
          title: 'notification',
          link: { name: 'profile-notification', params: {} },
          number: 2,
          icon: BIconLink,
        },
        {
          title: 'referral',
          link: { name: 'profile-referral', params: {} },
          number: 3,
          icon: BIconPeople,
        },

      ].filter(tab => !tab.hidden || tab.hidden !== true)
    },

  },
  watch: {
    route() {
      this.findTab()
    },
  },
  methods: {
    areObjectsEqual(obj1, obj2) {
      // Check if both arguments are objects
      if (typeof obj1 !== 'object' || typeof obj2 !== 'object') {
        return false
      }

      // Get the keys of both objects
      const keys1 = Object.keys(obj1)
      const keys2 = Object.keys(obj2)

      // Check if the number of keys is different
      if (keys1.length !== keys2.length) {
        return false
      }

      // Check if all keys and values in obj1 exist in obj2
      // eslint-disable-next-line no-restricted-syntax
      for (const key of keys1) {
        if (obj2[key] !== obj1[key]) {
          return false
        }
      }

      return true
    },
    findTab() {
      this.$nextTick(() => {
        const routeParams = JSON.parse(JSON.stringify(this.$route.params))
        delete routeParams.lang
        const tabNumber = this.filtredtabsItem.find(tab => (tab.link.name === this.$route.name
         && this.areObjectsEqual(routeParams, tab.link.params))).number
        if (tabNumber || tabNumber === 0) {
          this.tabNumber = tabNumber
        } else {
          throw new Error('cant find tab number')
        }
      })
    },
    tabClick(tab) {
      this.$router.push(tab.link)
    },
  },
}
